// Do not modify this file by hand!
// Re-generate this file by running lit-localize
import { html } from "lit";
import { str } from "@lit/localize";
/* eslint-disable no-irregular-whitespace */
/* eslint-disable @typescript-eslint/no-explicit-any */
export const templates = {
    h0fca6d6cbb0506c0: html `市场情报`,
    h229e7d06093c2f3f: html `ESG 与多样性`,
    h4b6568de605796be: html `董事会与治理`,
    h4e84df3b11ed9b4f: html `帮助与支持`,
    h722c4148bfbe6706: html `教育与认证`,
    h85f4df4fdcb8beed: html `风险与策略`,
    hb6b70f369f25a7ac: html `合规和道德`,
    hc639dc8eaab7815d: html `问题与报告`,
    hcd22a6d6c40d8786: html `审计与分析`,
    "link-home": `主页`,
    "nav-section-home": `主页`,
    s032cd9f1245d3645: `空格`,
    s08e6d298452e8f68: `审计`,
    s0910fa68dccfcaa6: `Data Market Intelligence`,
    s0a860146c6f28d97: `打开键盘快捷键对话框`,
    s0bae1af85a28bd4c: `Diligent Institute`,
    s0ccb779911d414a3: `资产库存`,
    s14ba513bc8896c24: `机器人`,
    s1534ff9f453525e1: `选择第一个单元格`,
    s175d37c8eb04d73e: `下载`,
    s1967ea0b8a2b6015: `运行选定的单元格`,
    s199f5853f4e718f7: `项目`,
    s24761a0cc8d9c0aa: `组织`,
    s299dc244af6aadff: `Customer Admin Boards`,
    s2aa747e75ad1b409: `Third-Party Manager`,
    s2b63dc08d32ccb09: `向上滚动`,
    s2c2b04f2561a1d4b: `Analytics`,
    s2cfcd4e06c146db9: `打开组织切换器对话框`,
    s2e109263b73c12d5: `许可证`,
    s34d94212c9758944: `战略`,
    s353873ecbaa3efe9: `向左箭头`,
    s3736464cf8d6fa08: `支持`,
    s392dc2954562a82b: `文本编辑器`,
    s39cccc90e6fe1d7f: `问题管理器`,
    s3ab6763097d7412f: `Equity Invest`,
    s3d5b54e4d176209c: `最后一张幻灯片`,
    s3f809b62bcc2a44c: `任务控制`,
    s45efff328e4d0a4d: `搜索组织`,
    s460bf77c46d93bb4: `关闭快捷键对话框`,
    s469437ae00d48e37: `展开当前行`,
    s47de2481b149190a: `实体`,
    s4802e47fe2e95134: `选项`,
    s480d27b7a8b69ce5: `向左滚动`,
    s49ca4bf0e63593da: `关闭对话框`,
    s4b10acae683d2978: `全屏`,
    s4b81aa9512692c4d: `折叠侧边导航栏`,
    s523eb9043213ff0d: `斜体`,
    s56410a6c80d5215c: `向下移动单元格`,
    s58622fa7922ed03b: `帮助菜单按钮`,
    s586d6bd2eca2da93: `用户`,
    s5a41c3a63f1c18af: `个人资料设置`,
    s5b56a21c08c842c4: `第一张幻灯片`,
    s5c1ecf88259b79f9: `展示`,
    s5cad0782f12d34b2: `Equity`,
    s5d9182f471cf98d1: `合规地图`,
    s5d929ff1619ac0c9: `搜索`,
    s5db46d120dcba694: `评估`,
    s5e27738a2e8eb763: `登录`,
    s5e8250fb85d64c23: `关闭`,
    s5febcd9b311c16fe: `向右滚动`,
    s60565faf8db3a5cb: `运行这个和上面的所有单元格`,
    s62bc518b503d1c76: `选择下面的单元格`,
    s63b6edf663b6a3c5: `添加下面的单元格`,
    s6d5cb7af3fa87c78: `任务跟踪器`,
    s6db55a42bcb74cfc: `问题跟踪器`,
    s6fb3409caa74b0a4: `Ctrl`,
    s70113bbc33303a81: `帮助菜单`,
    s7417792bbe720149: `重做`,
    s74cb3d66f6a668e1: `文档`,
    s7695095bb106d505: `Accuvio`,
    s7a4f059aaa029719: `Connect`,
    s7cfe12cd14df9950: `退出登录`,
    s7db511600050e797: `运行这个和下面的所有单元格`,
    s7deaf226ff8b192c: `安装程序`,
    s7e388025be643d0d: `Enter`,
    s7eb1e34fc5ece4cd: `个人资料菜单`,
    s884bcdca26998a48: `报告`,
    s89365ba6fa5cdb97: `停止执行`,
    s89ba33f94f92f3cc: `识别活动`,
    s8f4be9f086eb530f: `撤消`,
    s9021935bcdd703b9: `打开侧面板`,
    s9373ade6d85b4388: `收起当前行`,
    s947f21967d65c480: `软件商店`,
    s9ab2385df7adbce0: `突出显示一行`,
    s9dd12575273ac110: `向下滚动`,
    s9df9510d60035af3: `打开个人资料菜单`,
    s9f26843287bb592d: `组`,
    s9fda4232f5e1876a: `获取帮助`,
    sa05b93d8764f88ed: `风险管理器`,
    sa103c8e0c776e11c: `请求键盘快捷键`,
    sa153c163bc11460d: `活动中心`,
    sa35ed9234d3d66ce: `未找到任何组织`,
    sa4bb7742cdfc214e: `Director Boards`,
    sa872b0bfe51f2d40: `组织结构`,
    saed6432f1517ea10: `资产管理器`,
    saf7a5eef69e5bb59: `向上箭头`,
    sb061ff5a347a296e: `个人资料`,
    sb206d700d26b14ff: `下划线`,
    sb21cca7db5de38f3: `Storyboard`,
    sb284cd019b430d1e: `没有特定于应用程序的可用快捷键。`,
    sb32c8490570a8831: `幻灯片概述`,
    sb4484b8d878dffff: `活动日志`,
    sb752d83c4e4619bc: str `切换到 ${0}`,
    sb888017adf7992b9: `Diligent Academy`,
    sbd63362a31200ab4: `转到启动面板`,
    sbda32dab0c54ffdd: `下一张幻灯片`,
    sbf84c104b8212e06: `选择上面的单元格`,
    sc203eef710f83583: `我们不支持此应用程序的特定快捷键。`,
    sc2873891e8c3be68: `机器人应用程序脚本编辑器`,
    sc835e30bc3bdd2fd: `向上移动单元格`,
    sc8aa5792985e2ba3: `平台设置`,
    sca1a826088564455: `结果`,
    sca442b5dc0fd394c: `向下箭头`,
    scdd4399eeeacd8f4: `切换组织`,
    sd0864ea6cb6ef22e: `Community`,
    sd0b6082239185272: `全选`,
    sd1182e4e6a0ada64: `Policy Manager`,
    sd1b2ae9109b29cf0: `侧边导航`,
    sd1c09a62f063a73b: `任务管理器`,
    sd514ab1c93237dae: `保障计划`,
    sd76505ffae553332: `研究门户`,
    sd81eecf773db25fc: `按顺序运行所有单元格`,
    sd8f923198e0c5c6a: `End`,
    sd90a1e198e1ac71e: `退出`,
    sd9fb2375a5c991c5: `我们不支持此应用程序的特定快捷键，但如果您有任何建议，请告知我们。`,
    sdc599e1d5c823e75: `选择最后一个单元格`,
    sdcc5f064d591aefd: `上一张幻灯片`,
    se2faf168207b0a48: `框架`,
    se3b4c857f91f80d7: `键盘快捷键`,
    se65e4e6f3696e997: `培训`,
    se93a3eaf86201ae7: `Shift`,
    sed2d45e3f811c81d: `基本`,
    see0ef54044d25a50: `Book Admin Boards`,
    sf0d3b85da03d1e55: `删除选定的单元格`,
    sf2d615b20d62225a: `计划器`,
    sf41a0c89409353dc: `向右箭头`,
    sf5597bb9f2103d2a: `激活`,
    sf7c0eba7c822e3d6: `粗体`,
    sf95b10c03a2d5872: `打开侧边导航栏`,
    sf993c3199fefcb9c: `Alt`,
    sf9b1c0661a02d9f9: `配置`,
    sfc6b9ce43d2c798c: `时间表`,
    sfe3d666017079dce: `BoardEffect`,
    "shortcuts-home": `Home`,
};
